import { Box, Flex, useColorMode, useColorStyle } from '@tonic-one/react';
import EmailAndCollaborationProtection from '../components/EmailAndCollaborationProtection';
import EnableEmailAndCollaboration from './EnableEmailAndCollaboration';
import GradientBackground from '../components/GradientBackground';
import dashboardPreview from './images/dashboard-preview.svg';

const FoundationBasedEnableEmailAndCollaboration = ({
  provisionNewCas,
  actualProvisionNewCas,
  setLoading,
  isCreditOneConsumptionFeatureShow,
}: {
  provisionNewCas: () => void;
  actualProvisionNewCas: () => Promise<void>;
  setLoading: (load: boolean) => void;
  isCreditOneConsumptionFeatureShow: boolean;
}) => {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });

  return (
    <Box
      position="relative"
      width="100%"
      minHeight="100vh"
      backgroundColor={colorStyle.background.primary}
    >
      {/* Gradient Background */}
      <GradientBackground />

      <Flex
        flexDirection="column"
        alignItems="center"
        justifyContent="flex-start"
        width="100%"
        minHeight="100vh"
        px="96px"
        py="64px"
        position="relative"
        zIndex={1}
      >
        {/* Main Content */}
        <Box width="100%" maxWidth="832px" mb="24px">
          <EmailAndCollaborationProtection setLoading={setLoading} />
        </Box>

        {/* Action Buttons */}
        <Box width="100%" maxWidth="832px" mb="32px">
          <EnableEmailAndCollaboration
            provisionNewCas={provisionNewCas}
            actualProvisionNewCas={actualProvisionNewCas}
            isCreditOneConsumptionFeatureShow={
              isCreditOneConsumptionFeatureShow
            }
          />
        </Box>

        {/* Hero Graphic */}
        <Box width="100%" maxWidth="832px" position="relative">
          <img
            src={dashboardPreview}
            alt="Dashboard preview"
            style={{
              width: '100%',
              height: 'auto',
              objectFit: 'contain',
              display: 'block',
            }}
          />
        </Box>
      </Flex>
    </Box>
  );
};

export default FoundationBasedEnableEmailAndCollaboration;
